/**
 * Lag-debug rig — netcode-focused diagnostic surface.
 *
 * Opens the netcode tool family: Latency overlay, Net Traffic, Packet
 * Sparkline, Spike Analyzer, Server Tick badge, Lag Root Cause. Enables
 * both trackers so we capture frame-jitter + render rates while
 * inspecting netcode behavior.
 *
 * Use when investigating reconcile spikes, prediction divergence,
 * RTT regressions, server tick budget overruns, or bandwidth anomalies.
 *
 * Compare with `smoothness-arc` (overview verdict) — this rig is the
 * drill-down surface that pairs naturally as the "follow-up" view.
 */

import type { PlaytestRig } from '../environment/devConfig';

export const LAG_DEBUG_RIG: PlaytestRig = {
  enabled: true,
  label: 'lag-debug-2026-05-13',
  toolsToOpen: [
    'latency',
    'netTraffic',
    'netobsSparkline',
    'netSpike',
    'tickBadge',
    'lagRootCause',
    'positionTracker',
  ],
  enableFrameJitterTracking: true,
  enableReactRenderTracking: true,
  trackerEnableDelayMs: 10000,
};
